import { __decorate, __metadata } from "tslib";
import { Component, Input } from 'angular-ts-decorators';
import template from './product-item-features.component.html';
var ProductItemFeatures = (function () {
    function ProductItemFeatures() {
    }
    __decorate([
        Input(),
        __metadata("design:type", Array)
    ], ProductItemFeatures.prototype, "features", void 0);
    __decorate([
        Input(),
        __metadata("design:type", String)
    ], ProductItemFeatures.prototype, "fallback", void 0);
    ProductItemFeatures = __decorate([
        Component({
            selector: 'productItemFeatures',
            template: template,
        })
    ], ProductItemFeatures);
    return ProductItemFeatures;
}());
export { ProductItemFeatures };
